var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeaponsFirearms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      height: 512,
      width: 512
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-bg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h512v512H0z",
    fill: "#417505",
    fillOpacity: 0,
    transform: "translate(512, 512) scale(-1, -1) rotate(-180, 256, 256) skewX(0) skewY(0)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h512v512H0z",
    fill: "#417505",
    fillOpacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    className: "",
    transform: "translate(0,0)",
    style: {}
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M375.563 15.344c-3.744-.036-7.46.797-10.875 2.906-6.406 3.954-9.283 10.876-10.188 17.875v.03c-58.905 99.84-141.287 150.724-234.53 208.19-17.742 7.012-29.062 20.612-34.19 35.155-15.89-5.312-23.478-17.805-22.968-25.313l-18.656-1.28c-1.278 18.792 13.092 36.91 35.688 44.312l-1.656.5c-36.15 26.775-70.78 89.097-39.688 163.31 6.443 15.38 17.065 24.21 29.625 28.908 12.56 4.697 27.19 4.848 40 1.468 12.81-3.38 23.52-10.32 28.813-18.094 5.29-7.773 6.53-15.74.062-27.03-13.84-24.154-28.63-50.166-24.5-77.282 28.037 16.267 58.335 11.598 77.156-5.563 19.28-17.577 26.135-48.276 10.125-77.593 79.474-47.578 156.44-86.004 256.064-92.094 3.965.776 8.044.766 11.906-.53.022-.01.04-.025.063-.032.688-.024 1.37-.042 2.062-.063l-.375-.594c.75-.336 1.494-.707 2.22-1.155 6.83-4.218 9.65-11.82 10.342-19.28.693-7.463-.39-15.725-2.687-24.907-4.592-18.366-14.277-40.386-28.125-62.782-13.848-22.396-29.212-40.93-43.594-53.25-7.19-6.16-14.108-10.812-21.094-13.53-3.492-1.36-7.256-2.246-11-2.282zM375.188 34c.148-.01.326-.01.53 0 .82.043 2.094.296 4.063 1.063 3.94 1.532 9.573 5.047 15.72 10.312 12.293 10.53 26.843 27.85 39.844 48.875 13 21.026 21.982 41.773 25.906 57.47 1.962 7.846 2.61 14.454 2.22 18.655-.39 4.2-1.468 5.066-1.564 5.125-.095.06-1.343.595-5.28-.938-3.94-1.532-9.542-5.047-15.688-10.312-12.294-10.53-26.874-27.85-39.875-48.875-13.002-21.026-21.983-41.773-25.907-57.47-1.962-7.846-2.577-14.454-2.187-18.655.39-4.2 1.435-5.035 1.53-5.094.036-.022.24-.125.688-.156zM187.155 302.875c7.386 19.413 1.56 36.125-10.094 46.75-13.57 12.373-35.423 16.472-58.468 1.156 4.427-8.25 11.1-16.105 20.22-23.217 11.695-9.123 27.59-17.28 48.342-24.688z",
    fill: "#a36528",
    fillOpacity: 1,
    clipPath: "url(#icon-bg)",
    transform: "translate(512, 512) scale(-1, -1) rotate(-180, 256, 256) skewX(0) skewY(0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeaponsFirearms);
export default __webpack_public_path__ + "static/media/weapons-firearms.107600b7fb376b5f8bf12fa5dbf92cb7.svg";
export { ForwardRef as ReactComponent };